// extracted by mini-css-extract-plugin
export default {"container":"Accordion_container__x9GRR"};